module.exports = __webpack_public_path__ + "static/media/emoji-svgrepo-com.1ad810d5.svg";